import i18n from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector/cjs";
import { initReactI18next } from "react-i18next";

import deJSON from "./locales/de/common.json";
import enJSON from "./locales/en/common.json";
import frJSON from "./locales/fr/common.json";
import itJSON from "./locales/it/common.json";

const getLanguage = (languageCode: string) => languageCode.split("-")[0];

i18n
  .use(initReactI18next) // Initializes react-i18next
  .use(I18nextBrowserLanguageDetector)
  .init({
    debug: true,
    detection: {
      order: ["navigator"],
    },
    fallbackLng: "de", // Fallback language
    interpolation: { escapeValue: false },
    lng: localStorage.getItem("i18nextLng") ?? getLanguage(navigator.language), //Default language
    resources: {
      de: {
        translation: deJSON,
      },
      en: {
        translation: enJSON,
      },
      fr: {
        translation: frJSON,
      },
      it: {
        translation: itJSON,
      },
    },
  });

export default i18n;
